import React from "react";
import Card from "../components/Card";
import "../style/Work.css";

function Work({ setMode }) {
  return (
    <div
      className="work_container"
      style={{ backgroundColor: setMode[1], color: setMode[0] }}
    >
      <div className="work_head">
        <h1>WHAT I DO</h1>
      </div>
      <div className="work_cards">
        <Card
          logo={setMode[3]}
          title="Web Developer"
          text="I can make your websites with an awesome landing page. I create websites using either HTML, CSS, and JavaScript or react js. Tools I use are bootstrap 5, styled-components, and sometimes next js."
          bgColor={setMode[2]}
        />
        <Card
          logo={setMode[4]}
          title="Blockchain Developer"
          text="I build apps based on the Ethereum blockchain. I use solidity to write smart contracts, then hardhat to compile, test and deploy them, and finally ethers js to connect to the front end."
          bgColor={setMode[2]}
        />
      </div>
    </div>
  );
}

export default Work;
